import { Home, HomeTwoTone, Logout } from '@mui/icons-material';
import CategoryTwoToneIcon from '@mui/icons-material/CategoryTwoTone';
import FirstPageRoundedIcon from '@mui/icons-material/FirstPageRounded';
import GroupTwoToneIcon from '@mui/icons-material/GroupTwoTone';
import Groups2TwoToneIcon from '@mui/icons-material/Groups2TwoTone';
import LastPageRoundedIcon from '@mui/icons-material/LastPageRounded';
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone';
import { Box, Button, Divider, IconButton, ListItem, Stack, Tooltip, Typography, lighten, styled, useTheme } from '@mui/material';
import { NavLink as RouterLink } from 'react-router-dom';
import Logo from 'src/components/LogoSign';
import SystemStatus from 'src/components/systemStatus/SystemStatus';
import { useAuth } from 'src/features/authentication';
import TaskTwoToneIcon from '@mui/icons-material/TaskTwoTone';
import { useSidebarStore } from 'src/store/sidebar/sidebarStore';
import UserSettings from 'src/components/userSettings/UserSettings';

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3, 3),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
}));

const LogoAnimationBox = styled(Box)(() => ({
    animation: 'logoShowSideBar 1s ease 0s 1 normal forwards',
    '@keyframes logoShowSideBar': {
        '0%': {
            opacity: 0,
            transform: 'rotateY(100deg)',
            transformOrigin: 'left',
        },
        '100%': {
            opacity: 1,
            transform: 'rotateY(0)',
            transformOrigin: 'left',
        },
    },
}));

const NavButton = styled(Button)(({ theme }) => ({
    justifyContent: 'left',
    '&.active': {
        border: `1px solid ${theme.palette.primary.main}`,
        animation: 'borderAnimation 2s ease',
    },
    '&:hover': {
        transform: 'scale(1.02)',
    },
    '@keyframes borderAnimation': {
        '0%': {
            borderLeftColor: 'transparent',
            borderTopColor: 'transparent',
        },
        '20%': {
            borderTopColor: lighten(theme.palette.secondary.main, 0.5),
        },
        '50%': {
            borderLeftColor: lighten(theme.palette.secondary.main, 0.5),
        },
        '100%': {
            borderRightColor: theme.palette.secondary.main,
        },
    },
})) as typeof Button;

interface Props {
    shouldCloseOnClick?: boolean;
}

export default function SidebarContentAdmin({ shouldCloseOnClick = false }: Props) {
    const theme = useTheme();
    const { logout } = useAuth()
    const toggleSidebar = useSidebarStore((state) => state.toggleSidebar);
    const isSidebarOpen = useSidebarStore((state) => state.isSidebarOpen);

    const handleNavButtonClick = () => {
        if (shouldCloseOnClick) {
            toggleSidebar();
        }
    }

    const handleLogout = () => {
        console.log('logout')
        try {
            logout()
        } catch (err) {
            console.error(err);
        }
    }

    return (
        <>
            {isSidebarOpen &&
                <DrawerHeader id='sidebar-logo' sx={{ background: `linear-gradient(0deg, ${theme.palette.background.paper} 0%, ${theme.palette.primary.main} 80%)` }}>
                    <LogoAnimationBox>
                        <Logo width={250} />
                    </LogoAnimationBox>
                </DrawerHeader>
            }

            <Divider
                textAlign='right'
                id='sidebar-layout-divider'
                sx={{
                    mx: 1,
                    mt: isSidebarOpen ? 2 : `calc(${theme.header.height} + 20px)`,
                    alignItems: 'center'
                }}
            >
                {/* <HiddenWrapper mobileOnly>
                    <ThemeSwitch />
                </HiddenWrapper> */}
                <IconButton
                    color='secondary'
                    aria-label="open drawer"
                    onClick={() => toggleSidebar()}
                >
                    {isSidebarOpen ? <FirstPageRoundedIcon fontSize='medium' color='primary' id='sidebar-layout-close' /> : <LastPageRoundedIcon fontSize='medium' color='primary' id='sidebar-layout-open' />}
                </IconButton>
            </Divider>

            <Stack direction='column' justifyContent='space-between' sx={{ mt: 1.5, height: '100%' }}>
                <div>
                    {!isSidebarOpen && <Divider sx={{ my: 1, mx: 1 }} />}
                    <ListItem component='div'>

                        <NavButton
                            fullWidth
                            component={RouterLink}
                            to='/worker/home'
                            onClick={() => handleNavButtonClick()}
                            startIcon={
                                <Tooltip title='Home' placement='right'>
                                    <HomeTwoTone color='secondary' />
                                </Tooltip>
                            }
                        >
                            {isSidebarOpen ?
                                <Typography color='secondary' variant='h6'>Home</Typography>
                                : null
                            }
                        </NavButton>

                    </ListItem>
                    <ListItem component='div'>

                        <NavButton
                            fullWidth
                            component={RouterLink}
                            to='/worker/jobs'
                            onClick={() => handleNavButtonClick()}
                            startIcon={
                                <Tooltip title='Tasks' placement='right'>
                                    <TaskTwoToneIcon color='secondary' />
                                </Tooltip>
                            }
                        >
                            {isSidebarOpen ?
                                <Typography color='secondary' variant='h6'>Tasks</Typography>
                                : null
                            }
                        </NavButton>

                    </ListItem>
                </div>
                <div>
                    {/* <ListItem component='div' >
                        <UserSettings />
                    </ListItem> */}
                    <ListItem component='div' >
                        <Button
                            id='logout-button'
                            fullWidth
                            startIcon={<Logout color='secondary' />}
                            sx={{ justifyContent: 'left' }}
                            onClick={() => handleLogout()}
                        >
                            {isSidebarOpen ?
                                <Typography color='secondary' variant='h6'>Logout</Typography>
                                : null
                            }
                        </Button>

                    </ListItem>
                    <SystemStatus />
                </div>
            </Stack>
        </>
    );
}
